import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { listCreationPlans } from '@/lib/creationPlan';
import { CreatePlanChatStudio } from '@/components/createPlan/CreatePlanChatStudio';

/** Renders only when `projectId` was created by the create agent; reopens that conversation. */
export function CreateAgentBackButton({
  projectId,
  label = 'Back to agent',
  variant = 'outline',
  size,
  className,
  style,
  iconClassName = 'w-4 h-4',
}) {
  const navigate = useNavigate();
  const [planId, setPlanId] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setPlanId(null);
    if (!projectId) return undefined;
    let cancelled = false;
    listCreationPlans({ projectId, limit: 1 })
      .then((plans) => {
        if (!cancelled) setPlanId(plans[0]?.id || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  if (!planId) return null;

  return (
    <>
      <Button
        type="button"
        variant={variant}
        size={size}
        onClick={() => setOpen(true)}
        className={className}
        style={style}
        data-testid="back-to-create-agent"
        title="Reopen the create agent conversation that started this project"
      >
        <MessageSquare className={iconClassName} /> {label}
      </Button>
      <CreatePlanChatStudio open={open} resumePlanId={planId} navigate={navigate} onClose={() => setOpen(false)} />
    </>
  );
}

export default CreateAgentBackButton;
